import { combineReducers } from 'redux'
import general from './reducer.general'

// Yhdistetään kaikki reducerit rootReduceriin (index)
export default combineReducers({
  general,
})
